import { render, staticRenderFns } from "./FormDetails.vue?vue&type=template&id=18929136&scoped=true"
import script from "./FormDetails.vue?vue&type=script&lang=ts"
export * from "./FormDetails.vue?vue&type=script&lang=ts"
import style0 from "./FormDetails.vue?vue&type=style&index=0&id=18929136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18929136",
  null
  
)

export default component.exports